import AddNewsPage from "./AddNewsPage";

export default AddNewsPage;
